import { SettingsCard } from 'design-system';

import { dateFormatOptions } from '@/config/constants';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

import SettingsSelectRow from '../components/SettingsSelectRow';
import usePreferences from './usePreferences';

const Preferences = () => {
  const {
    timezone,
    changeUserSetting,
    dateFormat,
    timezoneOptions,
    marketsOptions,
    defaultMarket,
    homepage,
    homepageOptions,
    saving
  } = usePreferences();

  const isPersonalizationEnabled = useFlag(FeatureFlag.PersonalizationEnabled);

  return (
    <SettingsCard title='Preferences'>
      <SettingsSelectRow
        id='settings-timezone'
        disabled={saving}
        label='Timezone'
        options={timezoneOptions}
        value={timezone}
        onChange={userSetting => {
          changeUserSetting('timezone', userSetting);
        }}
      />
      <SettingsSelectRow
        id='settings-date-format'
        disabled={saving}
        label='Date Format'
        options={dateFormatOptions}
        value={dateFormat}
        onChange={userSetting => {
          changeUserSetting('dateFormat', userSetting);
        }}
      />
      {isPersonalizationEnabled ? (
        <SettingsSelectRow
          id='settings-homepage'
          disabled={saving}
          label='Homepage'
          options={homepageOptions}
          value={homepage}
          onChange={userSetting => {
            changeUserSetting('homepage', userSetting);
          }}
        />
      ) : (
        <SettingsSelectRow
          id='settings-default-market'
          disabled={saving}
          label='Default Market'
          options={marketsOptions}
          value={defaultMarket}
          onChange={userSetting => {
            changeUserSetting('defaultMarket', userSetting);
          }}
        />
      )}
    </SettingsCard>
  );
};

export default Preferences;
